// extracted by mini-css-extract-plugin
var _1 = "SendInviteField-modulecheckboxLabel__weL0B";
var _2 = "SendInviteField-modulecheckboxLabelTitle__ooj5J";
var _3 = "SendInviteField-modulenoticeFields__vLbJJ FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
var _4 = "SendInviteField-modulenoticeTextarea__iMNai";
export { _1 as "checkboxLabel", _2 as "checkboxLabelTitle", _3 as "noticeFields", _4 as "noticeTextarea" }
